<template>
  <div id="tab" class="video-item">
    <div class="title">
      <div class="left">
        <div class="line"></div>
        <span>{{ title }}</span>
      </div>
    </div>
    <div class="content">
      <div v-for="video in list" :key="video.id" style="cursor: pointer;" @click="videoPlay(video)">
        <div class="cover"><el-image :src="video.coverUrl" lazy></el-image></div>
        <div style="margin-top: 12px;">{{ video.title }}</div>
        <div style="color: #999999;">浏览量:{{ video.playTimes || 0 }}</div>
      </div>
    </div>
    <el-dialog custom-class="dialog" :title="detail.title" :visible.sync="dialogVisible" width="80%"
      @closed="dialogClosed">
      <video v-if="dialogVisible" controls autoplay :src="detail.videoUrl"></video>
    </el-dialog>
  </div>
</template>
  
<script>
// import { qrCodeGet } from '@/assets/js/common.js'
export default {
  name: "Yunsischool",
  props: ['column', 'title'],
  data() {
    return {
      list: [],
      detail: {},
      dialogVisible: false
    }
  },
  created() {
    this.getVideoList()
  },
  mounted() {

  },
  computed: {},
  methods: {
    async getVideoList() {
      console.log(this.column);
      const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/video/page', { column: [this.column], current: 1, size: -1 })
      console.log(res);
      if (res.code != 0) return this.$message.error(res.message)
      this.list = res.data.records
    },
    videoPlay(video) {
      this.detail = video
      this.dialogVisible = true
      this.$post(`/erpnew/account/c/reada46ceb/video/${video.id}/play`)
    },
    dialogClosed() {
      this.detail = {}
      this.dialogVisible = false
      this.getVideoList()
    }
  }
}
</script>
<style lang="less" scoped>
#tab {
  width: 100%;
  min-height: 100%;
  height: auto !important;
  font-size: 14px;
}

.video-item {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
  box-sizing: border-box;
  padding: 14px;

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #999999;
    flex-shrink: 0;

    .left {
      display: flex;
      align-items: center;
      color: #333333;
    }

    .line {
      width: 4px;
      height: 14px;
      border-radius: 170px;
      background: #FE2948;
      margin-right: 12px;
    }
  }

  .content {
    flex: 1 0 auto;
    display: flex;
    flex-wrap: wrap;
    grid-row-gap: 24px;
    grid-column-gap: 35px;
    margin-top: 10px;

    .cover {
      width: 200px;
      height: 120px;

      .el-image {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.dialog {
  video {
    width: 100%;
    height: 100%;
    max-height: 80vh;
  }
}</style>